import { APP_COLORS } from "../enums";

const customMuiCard: any = {
  styleOverrides: {
    root: {
      borderRadius: 16,
      border: `1px solid ${APP_COLORS.greyLight6}`,
      padding: 16,
      boxShadow: `0px 2px 2px 0px ${APP_COLORS.greyLight6}`,

    },
  },
  defaultProps: {
    elevation: 0,
  },
};

export { customMuiCard };
